import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';

/**
 * Resolves work-item vs JSM browse redirect from project type, issue key, and current search string.
 */
export function getWorkItemRedirectionPath(
	issueKey: string | undefined,
	projectType: ProjectType | undefined,
	searchQuery: string,
	userPreference: boolean = true,
	isEmbed: boolean = false,
	wivEnabledForProject: boolean = true,
): string | undefined {
	if (!issueKey || !projectType || searchQuery.includes('disableRedirect=true')) {
		return;
	}

	if (['software', 'business'].includes(projectType) && userPreference && wivEnabledForProject) {
		const embedPath = isEmbed ? '/embed' : '';
		return `/jira/browse/${issueKey}${embedPath}${searchQuery}`;
	}

	if (
		// eslint-disable-next-line jira/ff/no-preconditioning
		projectType === 'service_desk' &&
		fg('jsm_aniv_routing_phase_1') &&
		fg('jsm_aniv_route_redirection')
	) {
		const embedPath = isEmbed ? '/embed' : '';
		return `/browse/jsm-work-item/${issueKey}${embedPath}${searchQuery}`;
	}
}
